const promiseAreas = {
    auth: 'auth-area',
    tenant: 'tenant-area',
    checkin: 'checkin-area',
    checkout: 'checkout-area'
};

export default promiseAreas;
